import React, {Component} from "react";
import { connect } from 'react-redux';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';

import StaffEditForm from './StaffEditForm';
import { updateEmployee } from '../../actions/employeesActions';
import StaffListItem from "./StaffListItem";
import DetailTransaction from "./DetailTransaction";
import { getHeader } from "../../helper";
import CreateCompanyMessage from "../Account/CreateCompanyMessage";

class Staff extends Component {

    state = {
        screen: 'employee', //employee/create/transaction
        update: false,
        userSelected: null,
        transactionData: null,
        transactionNext: '',
        transactionLoading: false,
    }

    loadTransaction(user) {
        const {selectedCompany} = this.props;

        if(!user || !selectedCompany) return false;

        this.setState({
            userSelected: user,
            transactionLoading: true,
            screen: 'transaction',
        })

        axios.get(
            `${window.siteUrl}/api/v1/money_flow/?user_id=${user.user.id}&company_id=${selectedCompany.id}`,
            {
            headers: getHeader()
            }
        )
        .then(response => {
            this.setState({
                transactionData: response.data.results,
                transactionNext: response.data.next,
                transactionLoading: false,
            })
        })
        .catch(error => {
            console.error("get user transactions", error);
        });
    }

    onSubmit(e) {
        e.preventDefault();
        const user = this.state.userSelected;

        if(!user) return false;

        const payload = {
            user_id: user.user.id,
            company_id: user.company_id,
            set_admin: user.is_admin,
            balance_limit: parseFloat(user.balance_limit),
        };
        
        this.props.updateEmployee(
            payload,
            () => {
                this.onClose();

                Alert.success('Изменения сохранены', {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }
        );
    }

    onClose() {
        this.setState({
            screen: 'employee',
            update: false,
            userSelected: null,
        })
    }

    onMoreClick(link) {
        this.setState({
            transactionLoading: true
        })

        axios.get(
            link,
            {
            headers: getHeader()
            }
        )
        .then(response => {
            this.setState({
                transactionData: this.state.transactionData.concat(response.data.results),
                transactionNext: response.data.next,
                transactionLoading: false,
            })
        })
    }

    handleOnChange(value, field) {
        this.setState({
            userSelected:{
                ...this.state.userSelected,
                [field]: value
            }
        });
    }

    setUserStatus(user) {
        if(!user)
            return false;

        const payload = {
            user_id: user.user.id,
            company_id: user.company_id,
            set_block: !user.is_blocked
        };
        
        this.props.updateEmployee(
            payload,
            () => {
                Alert.success('Изменения сохранены', {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }
        );
    }

    render() {

        const {
            employees,
            companies,
            selectedCompany,
            handleCompany,
            deleteEmployee,
            session,
        } = this.props;

        if(!companies.data.results.length) {
            return <CreateCompanyMessage />
        }

        let options = [];
        companies.data.results.map((item, index) =>
            options.push({
                value: item.id,
                label: item.title,
            })
        );

        let currentUser = session.currentUser;

        let isAdmin = employees.admins.results.filter(item => item.user.id === currentUser.id);

        if(!selectedCompany){
            return false;
        };

        return(
            <div className="menu-content-staff menu-content-item tab-parent screen-bottom-block">

                <Alert stack={{limit: 1}} />

                <div className="rounded-white-block">
                    {
                        this.state.screen === 'employee'
                        ?
                        <div className="white-block-content">
                            <div style={{padding: '30px 30px 0 30px', display:'flex', flexDirection:'row'}}>
                                <div style={{flexGrow:1, marginRight: '20px'}}>                        
                                    <div style={{fontSize: '1rem', textTransform: 'uppercase', color: '#979797', marginBottom: '10px'}}>Выберите компанию</div>
                                    <Select
                                        name="company-list"
                                        noResultsText="Список пуст"
                                        value={selectedCompany && selectedCompany.id}
                                        onChange={(company) => handleCompany(company)}
                                        clearable={false}
                                        options={options}
                                    />
                                </div>

                                {
                                    isAdmin.length > 0 ?
                                    <div style={{display:'flex'}}>
                                        <div className="small-button" style={{alignSelf: 'flex-end'}}>
                                            <Link to="/account/entity/staff/create">
                                                <button style={{height: '36px', width:'auto', padding: '0 12px'}}>Добавить сотрудника</button>
                                            </Link>
                                        </div>
                                    </div>
                                    : null
                                }
                            </div>

                            <ul className="staff-list">
                                {
                                    employees.data.results.map((item, index) =>
                                        <StaffListItem
                                            key={index}    
                                            item = {item}
                                            isAdmin={isAdmin}
                                            currentUser={currentUser}
                                            handleEdit={(item) => this.setState({screen: 'edit',userSelected: item})}
                                            showTransaction={(item) => this.loadTransaction(item)}
                                            setUserStatus={(user) => this.setUserStatus(user)}
                                            deleteEmployee={deleteEmployee}
                                        />
                                    )
                                }
                            </ul>
                        </div>
                        :
                        this.state.screen === 'edit' ?
                        <StaffEditForm
                            selectedCompany={selectedCompany}
                            user={this.state.userSelected}
                            handleOnChange={(value, field) => this.handleOnChange(value, field)}
                            onSubmit={(e) => this.onSubmit(e)}
                            onClose={() => this.onClose()}
                        />
                        :
                        <DetailTransaction
                            user={this.state.userSelected}
                            selectedCompany={selectedCompany}
                            onClose={() => this.setState({userSelected: null, screen: 'employee', transactionData: null})}
                            onMoreClick={link => this.onMoreClick(link)}
                            data={this.state.transactionData}
                            next={this.state.transactionNext}
                            loading={this.state.transactionLoading}
                        />
                    }
                </div>
            </div>
        )

    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps, {updateEmployee})(Staff);


// WEBPACK FOOTER //
// ./src/components/AccountLaw/Staff.js